import React, { Component } from 'react';
import { Card, CardBody } from 'reactstrap';
import { Field } from 'redux-form';
import renderMultiSelectField from '../../../../shared/components/form/MultiSelect';
import {withTranslation} from "react-i18next";
import QuickAddCategory from './components/QuickAddCategory';

class CategoriesCard extends Component {

  render() {

    const { categories, t } = this.props;

    return (
      <Card>
        <CardBody>
          <div className="card__title">
            <h5 className="bold-text">{t('write.blog_categories.title')}</h5>
            <h5 className="subhead">{t('write.blog_categories.subtitle')}</h5>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">{t('write.blog_categories.select')}:</span>
            <div className="form__form-group-field">
              <Field
                name="categories"
                className="testowa"
                required={true}
                component={renderMultiSelectField}
                options={
                  categories ? categories.map(category => ({ value: category._id, label: category.name })) : []
                }
              />
            </div>
          </div>
          <QuickAddCategory {...this.props} />
        </CardBody>
      </Card>
    )

  }

}

export default withTranslation('dashboard')(CategoriesCard);
